import $axios from "../../../api/accessories";
import { $api } from "../../../api/api";

export default class FooterServices {
  static async Subscribe(email: string) {
    try {
      const response = await $axios.post($api("subscribe"), { email });
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async AllFooterSocialAccounts() {
    const res = await $axios.get($api("social_accounts"));
    return res;
  }
}


